<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
@if (fuseConfig.layout.style === "vertical-layout-1") {
    <vertical-layout-1></vertical-layout-1>
}
<!-- / VERTICAL LAYOUT 1 -->
